import { createApi } from "@reduxjs/toolkit/query/react";
import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import { transformResponseHandler } from "utils/transformResponseHandler";
import { customFetchBase } from ".";

const woundManagement = createApi({
  reducerPath: REDUCER_PATHS.WOUND_MANAGEMENT,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    /************
     * visit Api
     *************/

    visitListing: builder.query({
      query: (data) => ({
        url: `${apiConfig.VISIT_LISTING}?page=${data?.page}&pageSize=${data?.pageSize}&adminAction=${data?.adminAction}&sortColumn=${data?.sortColumn}&sortDirection=${data?.sortDirection}&searchText=${data?.searchText}`,
        method: "GET",
      }),
    }),
    woundListing: builder.query({
      query: (data) => ({
        url: `${apiConfig.WOUND_LISTING}/${data.woundId}`,
        method: "GET",
      }),
      providesTags: ["woundListing"],
    }),
    editWound: builder.mutation({
      query: ({ data, id }) => ({
        url: `${apiConfig.EDIT_WOUND}/${id}`,
        body: data,
        method: "PUT",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
      invalidatesTags: ["woundListing"],
    }),
    updateWoundStatus: builder.mutation({
      query: (data) => ({
        url: `/admin/wound/${data.woundId}/${data.status}`,
        method: "PATCH",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
      invalidatesTags: ["woundListing"],
    }),

    approveAssessment: builder.mutation({
      query: ({ type, _id, visitDate, action }) => ({
        url: `/admin/${type}/${_id}/${visitDate}/${action}`,
        method: "PATCH",
      }),
      transformResponse: (response, meta, arg) => {
        if (arg.action === "approve") {
          return transformResponseHandler(response);
        }
        return response;
      },
      invalidatesTags: ["woundListing"],
    }),
    assessmentListing: builder.query({
      query: (data) => ({
        url: `${apiConfig.EDIT_ASSESSMENT}/details/${data.assessmentId}`,
        method: "GET",
      }),
      providesTags: ["assessmentDetails"],
    }),
    editAssessmentDetails: builder.mutation({
      query: ({ id, data }) => ({
        url: `${apiConfig.EDIT_ASSESSMENT}/${id}`,
        method: "PUT",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
      invalidatesTags: ["assessmentDetails"],
    }),
    woundDetailsList: builder.query({
      query: ({ userId }) => ({
        url: `admin/${apiConfig.USER_WOUND_MANAGEMENT}?userId=${userId}`,
        method: "GET",
      }),
    }),
    woundPatientDetailsList: builder.query({
      query: ({ patientId }) => ({
        url: `admin/patient-management/wounds?patientId=${patientId}`,
        method: "GET",
      }),
    }),
    visitListDownload: builder.query({
      query: ({ patientId, visitDate }) => ({
        url: `/admin/wound/visit-list/download?patientId=${patientId}&visitDate=${visitDate}`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useLazyVisitListingQuery,
  useLazyWoundListingQuery,
  useEditWoundMutation,
  useUpdateWoundStatusMutation,
  useApproveAssessmentMutation,
  useLazyAssessmentListingQuery,
  useEditAssessmentDetailsMutation,
  useLazyWoundDetailsListQuery,
  useLazyWoundPatientDetailsListQuery,
  useLazyVisitListDownloadQuery,
} = woundManagement;

export default woundManagement;
